import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEdit, faTrash, faGift } from '@fortawesome/free-solid-svg-icons';

interface Marketor {
  id: number;
  twitch_user_id: string;
  twitch_display_name: string;
  email: string;
  name: string;
  refid: string;
  created_at: string;
  updated_at: string;
}

interface MarketorCardProps {
  marketor: Marketor;
  openViewModal: (marketor: Marketor) => void;
  openEditModal: (marketor: Marketor) => void;
  handleDeleteMarketor: (id: number) => void;
  openGiveawayAttemptsModal: (marketor: Marketor) => void;
}

const MarketorCard: React.FC<MarketorCardProps> = ({
  marketor,
  openViewModal,
  openEditModal,
  handleDeleteMarketor,
  openGiveawayAttemptsModal,
}) => {
  return (
    <div className="gothic-panel p-6 flex flex-col justify-between h-full">
      <div className="mb-4">
        <h3 className="gothic-heading text-2xl mb-2">{marketor.twitch_display_name || marketor.name || 'N/A'}</h3>
        <p className="gothic-text-silver text-sm mb-1"><strong>Email:</strong> {marketor.email}</p>
        <p className="gothic-text-silver text-sm mb-1"><strong>Twitch ID:</strong> {marketor.twitch_user_id}</p>
        <p className="gothic-text-silver text-sm mb-1"><strong>Ref ID:</strong> {marketor.refid}</p>
        <p className="gothic-text-silver text-xs mt-2">Created: {new Date(marketor.created_at).toLocaleString()}</p>
        <p className="gothic-text-silver text-xs">Updated: {new Date(marketor.updated_at).toLocaleString()}</p>
      </div>
      <div className="flex flex-wrap gap-2 justify-end">
        <button onClick={() => openViewModal(marketor)} className="gothic-button bg-gray-700 border-gray-600">
          <FontAwesomeIcon icon={faEye} /> View
        </button>
        <button onClick={() => openEditModal(marketor)} className="gothic-button bg-gray-700 border-gray-600">
          <FontAwesomeIcon icon={faEdit} /> Edit
        </button>
        <button onClick={() => handleDeleteMarketor(marketor.id)} className="gothic-button bg-gray-700 border-gray-600">
          <FontAwesomeIcon icon={faTrash} /> Delete
        </button>
        <button onClick={() => openGiveawayAttemptsModal(marketor)} className="gothic-button bg-blue-700 border-blue-600">
          <FontAwesomeIcon icon={faGift} /> Giveaways
        </button>
      </div>
    </div>
  );
};

export default MarketorCard;
